document.addEventListener('DOMContentLoaded', function () {
  // Select any form with class 'newsletter-form' AND form_type='customer'
  const newsletterForms = document.querySelectorAll('form.newsletter-form');

  newsletterForms.forEach((input) => {
    const form = input.closest('form'); // get the parent form
    if (!form) return;

    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton) return;

    submitButton.addEventListener('click', async function(e) {       
        if (form.checkValidity()) {

            e.preventDefault();
            e.stopImmediatePropagation();

            const email = form.querySelector('[name="contact[email]"]').value;
            const data = { type : 'welcome10', email : email };

            try {

                const res = await fetch('https://store.warnermusiccanada.com/email/send_notification.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                });

                // Show success message
                const success = form.querySelector('.optin-success');
                success.classList.add('show');
                setTimeout(() => {
                    success.classList.remove('show');
                    form.reset();
                }, 3000);

                } catch (error) {
                    console.error('Error submitting form:', error);
                }

            } else {
                form.reportValidity();
            }

    });
  });
});
